import { render, staticRenderFns } from "./ScrollToDiv.vue?vue&type=template&id=072c1d12&"
import script from "./ScrollToDiv.vue?vue&type=script&lang=js&"
export * from "./ScrollToDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072c1d12')) {
      api.createRecord('072c1d12', component.options)
    } else {
      api.reload('072c1d12', component.options)
    }
    module.hot.accept("./ScrollToDiv.vue?vue&type=template&id=072c1d12&", function () {
      api.rerender('072c1d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gNK8t62JzWNO/JS/comp/ScrollToDiv.vue"
export default component.exports